import { useMemo } from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";
import {
  usePreviewValidation,
  createValidationRules,
} from "@/features/previews/shared/hooks/usePreviewValidation";
import { ImagesTemplateTranslations } from "../types";

export const useImagesData = (props: QRProps<"image">) => {
  const { data, isInitPreview, context } = usePreviewData(props);
  const translations = props.previewTranslations?.["image"] as ImagesTemplateTranslations;

  usePreviewValidation({
    rules: [createValidationRules.arrayNotEmpty(() => data?.imageUrls || [])],
    dependencies: [data?.imageUrls],
    context,
    isInitPreview,
  });

  const processedData = useMemo(() => {
    if (!data) return null;

    return {
      albumTitle: data.albumTitle,
      albumDescription: data.albumDescription,
      albumWebsite: data.albumWebsite,
      buttonText: data.buttonText,
      buttonUrl: data.buttonUrl,
      imageUrls: data.imageUrls || [],
      themeColor: data.themeColor,
    };
  }, [data]);

  return {
    translations,
    isInitPreview,
    data: processedData,
  };
};
